import {
  AuthActionStack,
  AuthPageContainer,
} from '@affine/component/auth-components';
import { useI18n } from '@affine/i18n';
import type { ReactNode } from 'react';

import { Button } from '../../ui/button';

export const ExpiredPage = ({
  onOpenAffine,
  journey,
}: {
  onOpenAffine: () => void;
  journey?: ReactNode;
}) => {
  const t = useI18n();
  return (
    <AuthPageContainer
      visual="brand"
      title={t['com.streamlain.expired.page.title']()}
      subtitle={t['com.streamlain.expired.page.new-subtitle']()}
    >
      <AuthActionStack progress={journey}>
        <Button variant="primary" size="large" block onClick={onOpenAffine}>
          {t['com.streamlain.auth.open.streamlain']()}
        </Button>
      </AuthActionStack>
    </AuthPageContainer>
  );
};
